var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.opdracht.categorie
        ? _c("list-item", {
            attrs: { text: _vm.opdracht.categorie, title: "Categorie" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.opdracht.ambt
        ? _c("list-item", { attrs: { text: _vm.opdracht.ambt, title: "Ambt" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.opdracht.barema
        ? _c("list-item", {
            attrs: { text: _vm.opdracht.barema, title: "Barema" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.opdracht.functie
        ? _c("list-item", {
            attrs: { text: _vm.opdracht.functie, title: "Functie" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.opdracht.financiering
        ? _c("list-item", {
            attrs: {
              text:
                _vm.opdracht.financiering +
                " (" +
                _vm.opdracht.finStatContr +
                ")",
              title: "Financiering"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.opdracht.admToestand
        ? _c("list-item", {
            attrs: {
              text: _vm.opdracht.admToestand,
              title: "Administratieve toestand"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.opdracht.titularis
        ? _c("list-item", {
            attrs: { text: _vm.opdracht.titularis, title: "Titularis" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.opdracht.onderbreking
        ? _c("list-item", {
            attrs: { text: _vm.opdracht.onderbreking, title: "Onderbreking" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.opdracht.ambtswijziging === true
        ? _c("list-item", { attrs: { text: "Ja", title: "Ambtswijziging" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.opdracht.beslissingsnr
        ? _c("list-item", {
            attrs: {
              text: _vm.opdracht.beslissingsnr,
              title: "Beslissingsnummer"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm.isOpdPercShown(_vm.opdracht)
            ? _c("ratio-view", {
                staticClass: "mb-2 col-sm",
                attrs: {
                  numerator: _vm.opdracht.opdPerc,
                  title: "Opdrachtvolume"
                }
              })
            : _vm.isOpdUrenShown(_vm.opdracht)
            ? _c("ratio-view", {
                staticClass: "mb-2 col-sm",
                attrs: {
                  denominator: _vm.opdracht.urenNoemer,
                  numerator: _vm.opdracht.opdUren,
                  title: "Opdrachtvolume"
                }
              })
            : _c("ratio-view", {
                staticClass: "mb-2 col-sm",
                attrs: {
                  denominator: 0,
                  numerator: _vm.opdracht.periodeUren,
                  title: "Uren in periode"
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _vm.opdracht.periodeUren > 0
        ? _c("list-item", {
            attrs: {
              text: _vm.opdracht.einddatum
                ? _vm.opdracht.begindatum + " - " + _vm.opdracht.einddatum
                : "vanaf " + _vm.opdracht.begindatum,
              title: "Periode"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm.isNprShown(_vm.opdracht)
            ? [
                _vm.isNprPercShown(_vm.opdracht)
                  ? _c("ratio-view", {
                      staticClass: "mb-2 col-sm",
                      attrs: {
                        numerator: _vm.opdracht.tewPerc,
                        title: "Tewerkstellingsvolume"
                      }
                    })
                  : _c("ratio-view", {
                      staticClass: "mb-2 col-sm",
                      attrs: {
                        denominator: _vm.opdracht.urenNoemer,
                        numerator: _vm.opdracht.tewUren,
                        title: "Tewerkstellingsvolume"
                      }
                    }),
                _vm._v(" "),
                _vm.isNprPercShown(_vm.opdracht)
                  ? _c("ratio-view", {
                      staticClass: "mb-2 col-sm",
                      attrs: {
                        numerator: _vm.opdracht.nprPerc,
                        title: "Volume van de onderbreking"
                      }
                    })
                  : _c("ratio-view", {
                      staticClass: "mb-2 col-sm",
                      attrs: {
                        denominator: _vm.opdracht.urenNoemer,
                        numerator: _vm.opdracht.nprUren,
                        title: "Volume van de onderbreking"
                      }
                    })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.opdracht.mandaten.length > 0 ? _c("hr") : _vm._e(),
      _vm._v(" "),
      _vm.opdracht.mandaten.length > 0
        ? _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm" },
              [
                _c("mandaten-view", {
                  attrs: { mandaten: _vm.opdracht.mandaten }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }